<template>
  <v-dialog max-width="500" v-model="show" @click:outside="decline">
    <v-card class="bold-h2 pt-0">
      <v-window disabled v-model="step">
        <v-window-item disabled :value="1">
          <v-card-text class="body-1 pt-0">
            <v-col
              class="pt-0"
              align="center"
              justify="center"
              v-if="order.lockerOrder != null"
            >
              <p class="bold-header">
                {{ $t("open") }}
              </p>
              <p class="bold-number">
                {{ order.lockerOrder.lockerBoxes.length }}
              </p>
              <p class="bold-header mt-6">
                {{
                  (order.lockerOrder.lockerBoxes.length == 1
                    ? $t("lockers")
                    : $t("locker")) + "?"
                }}
              </p>
              <p
                v-if="order.lockerOrder.lockerBoxes.length > 1"
                class="bold-h3"
                style="color: #c94631"
              >
                {{ $t("more_than_one_locker") }}
              </p>
            </v-col>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="decline" class="button text-none">{{
              $t("cancel")
            }}</v-btn>
            <v-btn
              :loading="dialogIsLoading"
              @click="collectOrder"
              class="button text-none"
              >{{ $t("yes") }}</v-btn
            >
          </v-card-actions></v-window-item
        >
        <v-window-item disabled :value="2" class="pt-2">
          <v-col class="pa-0">
            <CreateLockerImage
              :lockers="
                order.pickupPoint != null ? order.pickupPoint.orderCapacity : 8
              "
              :lockerOrder="order.lockerOrder"
            />
          </v-col>
          <v-card-actions>
            <v-btn
              :loading="dialogIsLoading"
              @click="goToCustomer"
              class="button text-none"
              >{{ $t("locker_not_open") }}</v-btn
            >
            <v-spacer></v-spacer>

            <v-btn
              :loading="dialogIsLoading"
              @click="decline"
              class="button text-none"
              >{{ $t("done") }}</v-btn
            >
          </v-card-actions></v-window-item
        >
      </v-window>
    </v-card>
  </v-dialog>
</template>
<script>
import OrderAPI from "@/api/OrderAPI";
import CreateLockerImage from "@/components/lockerImageGenerator/CreateLockerImage.vue";
import { useRouter } from "vue-router";
export default {
  components: {
    CreateLockerImage,
  },
  data() {
    return {
      dialog: false,
      dialogIsLoading: false,
      step: 1,
    };
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    order: {
      type: Object,
      default: false,
    },
  },
  setup() {
    const router = useRouter();
    return { router };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },

  methods: {
    decline() {
      this.show = false;
      setTimeout(() => {
        this.step = 1;
      }, 500);
    },
    goToCustomer() {
      this.decline();
      this.router.push({
        name: "customerService",
      });
    },
    async collectOrder() {
      try {
        this.dialogIsLoading = true;
        await OrderAPI.collectOrder(this.order._id);
        this.dialogIsLoading = false;
        this.step = 2;
      } catch (error) {
        this.dialogIsLoading = false;
      }
    },
  },
};
</script>
<style>
.bold-number {
  font-size: 10rem;
  font-weight: 500;
  color: #003a70;
  line-height: 60pt;
  font-family: "serenity-bold", "agenda-light", Arial, sans-serif;
}
.bold-header {
  font-size: 4rem;
  font-weight: 500;
  line-height: 80pt;
  font-family: "serenity-bold", "agenda-light", Arial, sans-serif;
}
</style>
